// extracted by mini-css-extract-plugin
export default {"tabs":"SamplesPage_tabs__Vs2zj","root":"SamplesPage_root__uGZyF","component":"SamplesPage_component__6OgT3"};